import request from './request'

// 获取最新版本信息
export function getLatestVersion() {
  return request({
    url: '/AppPublish/GetLatest',
    method: 'post'
  })
}
